import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import HeaderBackgroundHeightFinder from './background-height';
import HeaderContext from './context';

const HeaderBackgroundContainer = ({ children, height, imgSrc, preset }) => {
  const [mounted, setMounted] = useState(false);
  const containerRef = useRef();
  const [backgroundHeight, setBackgroundHeight] = useState(
    containerRef.current
      ? containerRef.current.offsetTop + (height || containerRef.current.offsetHeight)
      : 0,
  );

  const updateBackgroundHeight = () => {
    setBackgroundHeight(
      containerRef.current
        ? containerRef.current.offsetTop + (height || containerRef.current.offsetHeight)
        : 0,
    );
  };

  useEffect(() => {
    // Trigger a render on mount in order to get the ref for the container height
    setMounted(true);
  }, []);

  useEffect(() => {
    updateBackgroundHeight();
  }, [containerRef]);

  return (
    <HeaderContext.Consumer>
      {({ backgroundColor, updateHeight, updateImage }) => {
        updateHeight(backgroundHeight);
        if (!preset) {
          updateImage(imgSrc);
        }

        return (
          <>
            <HeaderBackgroundHeightFinder
              containerRef={containerRef}
              fillColor={height || (imgSrc && mounted) ? null : backgroundColor}
              height={height}
            >
              {children}
            </HeaderBackgroundHeightFinder>
          </>
        );
      }}
    </HeaderContext.Consumer>
  );
};

HeaderBackgroundContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  height: PropTypes.number,
  imgSrc: PropTypes.string,
  preset: PropTypes.string,
};

HeaderBackgroundContainer.defaultProps = {
  height: null,
  imgSrc: null,
  preset: null,
};

export default HeaderBackgroundContainer;
